import { createI18n } from 'vue-i18n'
import { enUS } from './enUS'
import { esMX } from './esMX'

export const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: enUS,
    es: esMX,
  },
})
